// eslint-disable-next-line no-unused-vars
import { getBrowserLocale, /* isLocaleListed */ } from 'locales/utils'
import {
  SKIP_GOAL_SETTING,
  CHANGE_LOCALE,
  SHOW_LOCALE_MODAL,
  CLOSE_LOCALE_MODAL,
  SHOW_SUPPORT_CHAT,
  HIDE_SUPPORT_CHAT,
  SUPPORT_CHAT_IS_READY
} from '../actions/actionTypes'

const LOCAL_STORAGE_KEY = 'se_cabinet_settings'

const initialState = {
  locale: getBrowserLocale(),
  goalSettingSkip: [],
  localeModalIsVisible: false,
  supportChatIsVisible: false,
  supportChatIsReady: false,
}

const excludedLocalStorageKeys = [
  'localeModalIsVisible',
  'supportChatIsReady',
  'supportChatIsVisible'
]

const settings = (state = localStorageSync.syncInit(initialState), action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      localStorageSync.save({ ...state, locale: action.locale })
      document.location.reload(true)
      return { ...state, locale: action.locale }
    case SHOW_LOCALE_MODAL:
      return { ...state, localeModalIsVisible: true }
    case CLOSE_LOCALE_MODAL:
      return { ...state, localeModalIsVisible: false }
    case SKIP_GOAL_SETTING:
      localStorageSync.save({ ...state, goalSettingSkip: [...state.goalSettingSkip, action.data.goalSettingSkip] })
      return { ...state, goalSettingSkip: [...state.goalSettingSkip, action.data.goalSettingSkip] }
    case SHOW_SUPPORT_CHAT:
      return { ...state, supportChatIsVisible: true }
    case HIDE_SUPPORT_CHAT:
      return { ...state, supportChatIsVisible: false }
    case SUPPORT_CHAT_IS_READY:
      return { ...state, supportChatIsReady: true }
    default:
      return state
  }
}

const excludeKeysFromData = (data, keys) => {
  // eslint-disable-next-line no-underscore-dangle
  const _data = { ...data };
  keys.forEach(key => delete _data[key]);
  return _data;
}

const localStorageSync = {
  save: data => localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(excludeKeysFromData(data, excludedLocalStorageKeys))),
  reset: () => localStorage.removeItem(LOCAL_STORAGE_KEY),
  syncInit: initialState => {
    const storedData = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (!storedData) return initialState

    const parsedStoredData = JSON.parse(storedData)
    return { ...initialState, ...parsedStoredData }
  }
}

export default settings
